module.exports = __webpack_public_path__ + "static/media/apropo_2.6a20375c.jpg";